<template>
<!-- 数据统计-充值统计 -->
  <div class="index">
    <div class="stats">
      <el-row>
        <el-col style="width: 200px; margin-right: 20px">
          <el-input
            size="small"
            v-model="params.id"
            placeholder="用户UID搜索"
          ></el-input>
        </el-col>
        <el-col style="width: 200px; margin-right: 20px">
          <el-date-picker
            v-model="params.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-col>
        <el-col style="width: 200px; margin-right: 20px">
          <el-date-picker
            v-model="params.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-col>
        <el-select
          v-model="params.profit"
          style="width: 100px; margin-right: 20px"
          @change="getData"
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="预警用户" :value="1"></el-option>
        </el-select>
        <el-button type="primary" @click="getData">查询</el-button>
        <el-button type="primary" @click="sameCache" :loading="buttonLoading"
          >导出缓存</el-button
        >
        <el-button type="primary" @click="handleExport">导出</el-button>
        <el-button type="primary" @click="handleExportTotal"
          >导出总充值</el-button
        >
        <el-button type="primary" @click="getData('VIP')">VIP</el-button>
        <span>&nbsp;&nbsp;vip总盈亏：{{ profit_and_loss }}</span>
        <!-- <el-button type="primary" @click="handleExportMonth"
          >当月导出</el-button
        > -->
        <!-- <el-button type="primary" @click="handleExportYesterday"
          >昨日导出</el-button
        > -->
      </el-row>
      <el-row style="text-align: left">
        <el-date-picker
          v-model="rechargeTime"
          align="right"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          class="add-btn"
          style="margin-right: 20px"
          @click="exportData"
          >充值天数导出
        </el-button>
        <el-button
          type="primary"
          class="add-btn"
          style="margin-right: 20px"
          @click="exportRechargeData"
          >累充导出
        </el-button>
      </el-row>
      <p class="prompt">默认展示当天数据</p>
      <div>
        <el-table
          :data="dataList"
          @sort-change="handleSort"
          v-loading="loading"
        >
          <el-table-column
            prop="id"
            label="用户ID"
            width="100px"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="name" label="用户名"></el-table-column>
          <el-table-column prop="phone" label="电话"></el-table-column>
          <el-table-column prop="min_roll" label="min_roll"></el-table-column>
          <el-table-column
            prop="recharge_amount"
            label="充值金额"
            sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="backpack_amount"
              label="背包余额"
              sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="account_balance"
            label="钻石余额"
            sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="shop_balance"
              label="商城余额"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="exp_boxes_price"
              label="钥匙价值"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="extract_get_out_amount"
              label="提取金额"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="extract_transfer_amount"
              label="转赠金额"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="transfer2_amount"
              label="转赠2"
              sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="profit_amount"
            label="盈亏"
            sortable="custom"
          ></el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { server, postData, delData, patchData, getData, getApiData, postApiData, patchApiData, api } from '@/http'


export default {
  data() {
    return {
      loading: false,
      buttonLoading: false,//按钮动画
      exportButtonLoading: false,//导出按钮动画
      dataList: undefined,
      dataMeta: {},
      profit_and_loss: 0,//vip总盈亏
      rechargeTime: undefined, //充值天数数据
      params: {
        id: undefined,
        name: undefined,
        email: undefined,
        phone: undefined,
        start_time: undefined,
        end_time: undefined,
        page: undefined,
        order_field: 'id',
        order_sort: 'desc',
        profit: 0,//是否要筛选预警用户的字段 0是查全部 1是筛选
      }
    }
  },
  methods: {
    sameCache() {
      //当月导出缓存
      if (!this.params.start_time) {
        this.$message.error("请选择开始时间")
        return
      }
      if (this.buttonLoading) {
        this.$message.warning("请稍等，正在缓存中...")
        return
      }
      this.buttonLoading = true
      getApiData('cache_recharge_export', {
        ...this.params
      })
        .then(res => {
          this.$message.success(res.message ? res.message : '缓存成功！')
        })
        .finally(() => {
          // this.$message.warning("请稍等，正在缓存中...")
          this.buttonLoading = false
        })
    },
    handleExport() {
      //导出
      this.$prompt('请输入上级id(多个id用英文逗号,隔开)，不填则导出全部', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        window.open(`${api}recharge_export?pid=${value ? value : ''}`)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消导出'
        });
      });
    },
    handleExportTotal() {
      //导出总充值
      window.open(`${server}users_recharge_export`)
    },
    handleExportMonth() {
      //导出当月
      if (this.params.end_time && !this.params.start_time) {
        this.$message.error("请选择开始时间")
        return
      }
      if (this.params.start_time || this.params.end_time) {
        window.open(`${api}recharge_export?type=1&start_time=${this.params.start_time}&end_time=${this.params.end_time}`)
      } else {
        window.open(`${api}recharge_export?type=1`)
      }
    },
    handleExportYesterday() {
      //导出昨天
      window.open(`${api}recharge_export?type=2`)
    },
    getData(parameter) {
      if (parameter === 'VIP') {
        this.params.special_enable = 1;
      } else {
        this.params.special_enable = 0;
      }
      this.loading = true
      getApiData('recharge_statistics', {
        ...this.params
      })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
          //计算vip的盈亏
          if (parameter === 'VIP') {
            this.profit_and_loss = 0
            let sum = 0
            for (let i = 0, len = res.data.length; i < len; i++) {
              sum += res.data[i].profit_amount
            }
            this.profit_and_loss = sum
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSort(column) {
      this.params.order_field = column.prop
      this.params.order_sort = column.order === 'ascending' ? 'asc' : 'desc'
      this.params.page = 1
      this.getData()
    },
    handlePageChange(page) {
      this.params.page = page
      this.getData()
    },
    exportData() {
      //导出对战每日数据
      if (!this.rechargeTime) {
        this.$message.error("请先选择导出日期")
        return
      }
      const d = new Date(this.rechargeTime)
      const resDate = d.getFullYear() + '-' + this.supplement((d.getMonth() + 1))
      window.open(`${api}recharge_days_export?date=${resDate}`)
    },
    exportRechargeData() {
      window.open(`${api}recharge_red_envelopes_export`)
    },
    supplement(s) {
      return s < 10 ? '0' + s : s
    },
  },
  created() {
    this.getData()
  }
}
</script>

<style>
</style>
